export default "__VITE_ASSET__a7gd3pvD__"